import SeismicEvent from './SeismicEvent';
export default SeismicEvent;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicEvent/index.js